import { Dispatch } from 'redux';
import Errors from '../../../shared/validation/errors';
import LocalStorageUtils from '../../../utils/local-storage';
import headersBuilder, { Method, buildPublicGetRequest } from '../../../utils/request';

export const FETCH_CONFIG = 'FETCH_CONFIG';
export const FETCH_LANG_JSON = 'FETCH_LANG_JSON';
export const FETCH_CONFIG_SHARED = 'FETCH_CONFIG_SHARED';

declare global {
  interface Window {
    gtag: any;
  }
}

export type FetchConfigAction = {
  type: string;
  config: any;
};

export type FetchLanguageJSONAction = {
  type: string;
  langFile: any;
};

const fetchConfig = (config: any): FetchConfigAction => {
  return {
    type: FETCH_CONFIG,
    config
  };
};

const fetchConfigShared = (config: any): FetchConfigAction => {
  return {
    type: FETCH_CONFIG_SHARED,
    config
  };
};

const fetchConfigAsync = () => {
  return (dispatch: Dispatch): void => {
    fetch('/conf.json').then((response) =>
      response
        .json()
        .then((json: any) => {
          LocalStorageUtils.putValueToLocalStorage('apiUrl', json?.api);
          const enableGoogleAnalytics = json?.enableGoogleAnalytics ?? false;
          LocalStorageUtils.putValueToLocalStorage('enableGoogleAnalytics', enableGoogleAnalytics.toString());
          dispatch(fetchConfig(json));
        })
        .catch((error) => Errors.throwErrorMessage(error))
    );
  };
};

const fetchLanguageJSON = (langFile: any): FetchLanguageJSONAction => {
  return {
    type: FETCH_LANG_JSON,
    langFile
  };
};

export const fetchSharedSettingsAsync = (api: string) => {
  return (dispatch: Dispatch): void => {
    if (!api) {
      return;
    }

    fetch(`${api}/settings/common/shared`, buildPublicGetRequest())
      .then((response: Response) => {
        // Some environments still require auth on this route.
        if (response.status !== 401) {
          return response;
        }

        return fetch(`${api}/settings/common/shared`, headersBuilder(Method.GET));
      })
      .then((response: Response) => {
        if (!response.ok) {
          return null;
        }
        return response.json();
      })
      .then((json: any) => {
        if (!json) {
          return;
        }

        dispatch(fetchConfigShared(json));
      })
      .catch(() => {
        // Ignore errors: keep current frontend values.
      });
  };
};

export const fetchLanguageJSONAsync = (lang: string) => {
  return (dispatch: Dispatch): void => {
    fetch(`/i18n/${lang}.json`)
      .then((response) => response.json())
      .then((json: any) => {
        dispatch(fetchLanguageJSON(json));
        window.gtag('event', 'PAMM_custom', {
          lang_JSON: lang
        });
      })
      .catch((error) => Errors.throwErrorMessage(error));
  };
};

export default fetchConfigAsync;
